import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import notifications from 'reducers/notification';
import files from 'reducers/fileselector';
import groups from 'reducers/imagegroup';
import imageList from 'reducers/imagelist';
import cropper from 'reducers/cropper';
import searchList from 'reducers/searchlist';
import user from 'reducers/user';
import image from 'reducers/image';

const flockrApp = combineReducers({
  notifications,
  files,
  imageList,
  cropper,
  groups,
  searchList,
  user,
  image,
  routing: routerReducer
})

export default flockrApp;



/** WEBPACK FOOTER **
 ** ./redux/configureStore.js
 **/